// extracted by mini-css-extract-plugin
export default {"wrapper":"EdgeDeviceDataMinng_wrapper__-OXOe"};